<template>
  <button
    v-if="showButton"
    @click="page +=1"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    eventsId: {
      type: String,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      page: 1,
      events: null,
      shouldShowButton: true,
    }
  },
  computed: {
    showButton () {
      /* if (this.events === null) {
        return true
      }

      if (this.events === '') {
        return false;
      }
      
      const eventsFound = this.events.match(new RegExp('events__event', "g")).length;
      //alert(eventsFound);
      return eventsFound < this.totalCount; */
      return this.shouldShowButton;
    }
  },
  watch: {
    page: {
      handler() {
        this.fetchEvents()
      },
    },
  },
  methods: {
    async fetchEvents() {
      try {
        const data = await (
          await fetch(`/wp-admin/admin-ajax.php?action=events&page=${this.page}`)
        ).text()
        
        const target = document.getElementById(this.eventsId);
        
        target && (this.events += data)
        target && (target.innerHTML += data)
        const eventsFound = target.innerHTML.match(new RegExp('events__event', "g")).length;
        if(eventsFound == this.totalCount){
          this.shouldShowButton = false;
        }
      } catch (e) {}
    },
  },
}
</script>
